/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaCancelOrderInfoVo } from './KoreaCancelOrderInfoVo';
import {
    KoreaCancelOrderInfoVoFromJSON,
    KoreaCancelOrderInfoVoFromJSONTyped,
    KoreaCancelOrderInfoVoToJSON,
    KoreaCancelOrderInfoVoToJSONTyped,
} from './KoreaCancelOrderInfoVo';

/**
 * 
 * @export
 * @interface ResponseListKoreaCancelOrderInfoVo
 */
export interface ResponseListKoreaCancelOrderInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListKoreaCancelOrderInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListKoreaCancelOrderInfoVo
     */
    message?: string;
    /**
     * 
     * @type {Array<KoreaCancelOrderInfoVo>}
     * @memberof ResponseListKoreaCancelOrderInfoVo
     */
    data?: Array<KoreaCancelOrderInfoVo>;
}

/**
 * Check if a given object implements the ResponseListKoreaCancelOrderInfoVo interface.
 */
export function instanceOfResponseListKoreaCancelOrderInfoVo(value: object): value is ResponseListKoreaCancelOrderInfoVo {
    return true;
}

export function ResponseListKoreaCancelOrderInfoVoFromJSON(json: any): ResponseListKoreaCancelOrderInfoVo {
    return ResponseListKoreaCancelOrderInfoVoFromJSONTyped(json, false);
}

export function ResponseListKoreaCancelOrderInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListKoreaCancelOrderInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(KoreaCancelOrderInfoVoFromJSON)),
    };
}

export function ResponseListKoreaCancelOrderInfoVoToJSON(json: any): ResponseListKoreaCancelOrderInfoVo {
    return ResponseListKoreaCancelOrderInfoVoToJSONTyped(json, false);
}

export function ResponseListKoreaCancelOrderInfoVoToJSONTyped(value?: ResponseListKoreaCancelOrderInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(KoreaCancelOrderInfoVoToJSON)),
    };
}

